export const navigationTranslations = {
    tabs: {
        watches: {
            en: "watches",
            de: "uhren",
            zh: "腕錶",
            fr: "montres"
        },
        jewellery: {
            en: "jewellery",
            de: "schmuck",
            zh: "珠寶",
            fr: "joaillerie"
        },
        tourmalines: {
            en: "tourmalines",
            de: "turmaline",
            zh: "碧璽",
            fr: "tourmalines"
        },
        philosophy: {
            en: "philosophy",
            de: "philosophie",
            zh: "哲學",
            fr: "philosophie"
        },
        maison: {
            en: "maison",
            de: "haus",
            zh: "品牌",
            fr: "maison"
        },
        important_objects: {
            en: "important objects",
            de: "herausragende Objekte",
            zh: "重要之物",
            fr: "objets importants"
        },
        stores: {
            en: "stores",
            de: "geschäfte",
            zh: "商店",
            fr: "boutiques"
        }
    },
    subtabs: {
        collections: {
            en: "collections",
            de: "kollektionen",
            zh: "系列",
            fr: "collections"
        },
        movements: {
            en: "movements",
            de: "uhrwerk",
            zh: "機芯",
            fr: "mouvements"
        },
        elements: {
            en: "elements",
            de: "komponenten und elemente",
            zh: "部件",
            fr: "éléments"
        },
        rings: {
            en: "rings",
            de: "ringe",
            zh: "戒指",
            fr: "bagues"
        },
        bracelets: {
            en: "bracelets",
            de: "armbänder",
            zh: "手鐲",
            fr: "bracelets"
        },
        necklaces: {
            en: "necklaces",
            de: "halsketten",
            zh: "項鍊",
            fr: "colliers"
        },
        earrings: {
            en: "earrings",
            de: "ohrringe",
            zh: "耳環",
            fr: "boucles d'oreilles"
        },
        made_to_order: {
            en: "made to order",
            de: "nach maß",
            zh: "定制",
            fr: "sur mesure"
        },
        company: {
            en: "company",
            de: "unternehmen",
            zh: "公司",
            fr: "entreprise"
        },
        our_innovations: {
            en: "our innovations",
            de: "unsere innovationen",
            zh: "我們的創新",
            fr: "nos innovations"
        },
        commitments: {
            en: "commitments",
            de: "verpflichtungen",
            zh: "承諾",
            fr: "engagements"
        },
        the_biggest_gemstone: {
            en: "The biggest gemstone",
            de: "Der größte Edelstein",
            zh: "最大的寶石",
            fr: "La plus grande pierre précieuse"
        },
        stores: {
            en: "stores",
            de: "geschäfte",
            zh: "商店",
            fr: "boutiques"
        },
        philosophy: {
            en: "philosophy",
            de: "philosophie",
            zh: "哲學",
            fr: "philosophie"
        },
        tourmalines: {
            en: "tourmalines",
            de: "turmaline",
            zh: "碧璽",
            fr: "tourmalines"
        },
        clockwork: {
            en: "clockwork",
            de: "uhrwerk",
            zh: "新的機芯",
            fr: "mouvement"
        }
    },
    products: {
        // Watches
        lucidity: {
            en: "LUCIDITY",
            de: "LUCIDITY",
            zh: "LUCIDITY",
            fr: "LUCIDITY"
        },
        introsistence: {
            en: "INTROSISTENCE",
            de: "INTROSISTENCE",
            zh: "INTROSISTENCE",
            fr: "INTROSISTENCE"
        },
        determination: {
            en: "DETERMINATION",
            de: "DETERMINATION",
            zh: "DETERMINATION",
            fr: "DETERMINATION"
        },
        realization: {
            en: "REALIZATION",
            de: "REALIZATION",
            zh: "REALIZATION",
            fr: "REALIZATION"
        },
        connaissance: {
            en: "CONNAISSANCE",
            de: "CONNAISSANCE",
            zh: "CONNAISSANCE",
            fr: "CONNAISSANCE"
        },
        essence_desthetique: {
            en: "ESSENCE D'ESTHÉTIQUE",
            de: "ESSENCE D'ESTHÉTIQUE",
            zh: "ESSENCE D'ESTHÉTIQUE",
            fr: "ESSENCE D'ESTHÉTIQUE"
        },
        // Movements
        atomic: {
            en: "ATOMIC",
            de: "atomuhr",
            zh: "原子鐘",
            fr: "ATOMIQUE"
        },
        clockworklight: {
            en: "LIGHT",
            de: "lichtuhr",
            zh: "光動表",
            fr: "LUMIÈRE"
        },
        // Elements
        cypher_glass: {
            en: "CYPHER GLASS",
            de: "CYPHER GLASS",
            zh: "CYPHER GLASS",
            fr: "VERRE CYPHER"
        },
        diamondglass: {
            en: "DIAMOND GLASS",
            de: "DIAMANTGLAS",
            zh: "鑽石錶鏡",
            fr: "VERRE DIAMANT"
        },
        tourmaline_frequencies: {
            en: "TOURMALINE FREQUENCIES",
            de: "TOURMALINE FREQUENCIES",
            zh: "TOURMALINE FREQUENCIES",
            fr: "FRÉQUENCES DE TOURMALINE"
        },
        tourmalines: {
            en: "tourmalines",
            de: "tourmaline",
            zh: "碧璽",
            fr: "tourmalines"
        },
        // Jewellery Collections
        snake: {
            en: "snake",
            de: "snake",
            zh: "蛇",
            fr: "serpent"
        },
        fluoring: {
            en: "fluoring",
            de: "fluoring",
            zh: "螢光戒指",
            fr: "fluoring"
        },
        tourmaline: {
            en: "tourmaline",
            de: "tourmaline",
            zh: "碧璽",
            fr: "tourmaline"
        },
        chinese_zodiacs: {
            en: "chinese zodiacs",
            de: "chinesische tierkreiszeichen",
            zh: "十二生肖",
            fr: "zodiaques chinois"
        },
        // Philosophy
        vision: {
            en: "VISION",
            de: "VISION",
            zh: "願景",
            fr: "VISION"
        },
        books: {
            en: "BOOKS",
            de: "BÜCHER",
            zh: "書籍",
            fr: "LIVRES"
        },
        // Company
        our_story: {
            en: "OUR STORY",
            de: "UNSERE GESCHICHTE",
            zh: "我們的故事",
            fr: "NOTRE HISTOIRE"
        },
        // Innovations
        floating_figures: {
            en: "FLOATING FIGURES",
            de: "FLOATING FIGURES",
            zh: "FLOATING FIGURES",
            fr: "FIGURES FLOTTANTES"
        },
        innovation_diamond_glass: {
            en: "DIAMOND GLASS",
            de: "DIAMOND GLASS",
            zh: "DIAMOND GLASS",
            fr: "VERRE DIAMANT"
        },
        innovation_light_watch: {
            en: "GEM CUTS",
            de: "LIGHT WATCH",
            zh: "LIGHT WATCH",
            fr: "TAILLES DE GEMMES"
        },
        innovation_tourmaline_frequencies: {
            en: "TOURMALINE FREQUENCIES",
            de: "TOURMALINE FREQUENCIES",
            zh: "TOURMALINE FREQUENCIES",
            fr: "FRÉQUENCES DE TOURMALINE"
        },
        innovation_special_cuts: {
            en: "LIGHT WATCH",
            de: "LIGHT WATCH",
            zh: "LIGHT WATCH",
            fr: "MONTRE LUMINEUSE"
        },
        the_biggest_gemstone: {
            en: "THE BIGGEST GEMSTONE",
            de: "DER GRÖßTE EDELSTEIN",
            zh: "最大的寶石",
            fr: "LA PLUS GRANDE PIERRE PRÉCIEUSE"
        },
        stores: {
            en: "stores",
            de: "geschäfte",
            zh: "商店",
            fr: "boutiques"
        },
        // Important Objects
        skridblatnir: {
            en: "The magical ship Skidbladnir",
            de: "Das magische Schiff Skidbladnir",
            zh: "魔法船 Skidbladnir",
            fr: "Le navire magique Skidbladnir"
        },
        money_art: {
            en: "Money Art",
            de: "Geld Kunst",
            zh: "钱币艺术",
            fr: "Art de l'argent"
        },
        fidrildi_stone: {
            en: "Fidrildi and the Philosopher's Stone",
            de: "Fidrildi und der Stein der Weisen",
            zh: "菲德里尔迪与贤者之石",
            fr: "Fidrildi et la pierre philosophale"
        },
        infinite_insight: {
            en: "The infinite delivery of insight",
            de: "Die unendliche Lieferung von Einsicht",
            zh: "无限洞察力的传递",
            fr: "La livraison infinie de perspicacité"
        }
    },
};
